export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-19.jpg'),
        title: '软件开发与维护',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: ' 企业应用系统运维',
      description: `<p style="font-size:1.05rem">随着企业信息化的不断深入，信息系统变得庞大而复杂。 企业应用系统运维的难度和压力也在增加。MaesInfo提供定制的应用系统设计和开发服务，并在预算范围内按时和按质提供项目。 我们可以帮助客户确定应用系统或产品的特定要求，并管理和维护其整个生命周期。
Maesinfo依靠经验丰富的全球开发团队和技术专家为客户提供更加标准化和专业化的定制应用系统和解决方案。 我们的团队和专家还可以使应用系统更高效，更稳定地运行，并且我们还可以及时响应应用系统的各种故障。</p>`
    },
    {
      title: '我们可以提供:',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-19.jpg')+`)"></span>
      <span class="list">
      <i></i>行业应用开发和维护<br/>
      <i></i>定制软件包服务<br/>
      <i></i>移动应用和嵌入式开发<br/>
      <i></i>增值服务的应用开发<br/>
      <i></i>供应链管理应用程序开发<br/>
      <i></i>企业应用程序集成<br/>
      <i></i>应用系统生命周期支持<br/>
      <i></i>面向服务的体系结构（SOA）<br/>
      <i></i>质量保证和测试

      </span>`
    }
  ]
}
